import React, { FC, memo, useEffect, useState } from 'react'
import SingleInputHeader from './header/SingleInputHeader'
import SingleInputDetail from './detail/SingleInputDetail'
import { Dirary } from '../../types/dirary'
import classes from './SingleInputMain.module.scss'
import { useRecoilState } from 'recoil'
import { User } from '../../types'
import { userState } from '../../states/userState'
import { formatDate } from '../../utils/functions/formatting'
import {
  createDefaultDiary,
  nullADiaryList,
} from '../../utils/functions/createDefaultDiary'
import { useCheckSendable } from '../../hooks/singleInput/useCheckSendable'
import { calcTotalTimeByDiary } from '../../utils/functions/calcTotalTime'
import { useCheckDiaryList } from '../../hooks/singleInput/useCheckDiaryList'
import { formatWorkerId } from '../../utils/variables/workerId'
// const dummyData: Dirary[] = [
//   {
//     id: 1,
//     workerId: 1,
//     workerName: "山田太郎",
//     departmentId: 1,
//     affiliationFactoryId: 1,
//     jobId: 1,
//     workingDate: "2022-01-01",
//     factoryId: 51,
//     constructionId: 1,
//     startTime: "09:00",
//     endTime: "18:00",
//     isBreak: false,
//     totalWorkingTimeByHour: 1.5,
//     totalWorkingTimeByMinute: 0,
//     productNo: "123456",
//     productNo1: 1,
//     productNo2: 1,
//     siteName:
//       "テスト現場名1 テスト現場名1 テスト現場名1 テスト現場名1 テスト現場名1 テスト現場名2",
//     slipNumber: "1234567",
//     processName: "現場代理人専用作業日報",
//     processId: "1024",
//     estimatedTime: 8,
//     workingTimeByHour: 1.5,
//     workingTimeByMinute: 90,
//     comment: "コメント",
//   },
// ];
export type workerInfoType = {
  workerId: string
  workerName: string
  departmentId: null | number
  departmentName: null | string
  place: null | string
  jobId: null | number
}
type Props = {
  dateStringFromOtherPage?: string
  workerIdFromOtherPage?: string
  fromOtherPage?: boolean
  setIsShow?: React.Dispatch<React.SetStateAction<boolean>>
  callFrom?: string
  initialProductNo?: string
  initialProductBno?: string
}
const SingleInputMain: FC<Props> = memo((props) => {
  const {
    fromOtherPage = false,
    setIsShow = undefined,
    workerIdFromOtherPage = '',
    dateStringFromOtherPage = '',
    callFrom = '',
    initialProductNo = '',
    initialProductBno = '',
  } = props
  const { checkDiaryListSendable } = useCheckSendable()
  const [user, setUser] = useRecoilState<User>(userState)
  //読み込んだ日報リスト
  const [fetchDiaryList, setFetchDiaryList] = useState<Dirary[]>([])
  //作成した日報リスト
  const [diaryList, setDiaryList] = useState<Dirary[]>([])
  //追加・削除・更新日報リスト
  const { addDiaryList, deleteDiaryList, updateDiaryList } = useCheckDiaryList(
    diaryList,
    fetchDiaryList
  )
  //デフォルトの日報（単体）
  const [defaultDiary, setDefaultDiary] = useState<Dirary>(nullADiaryList)
  //デフォルトの製番（単体）
  const [defaultProductNo, setDefaultProductNo] = useState<string>(
    user.initialParameters.productNoForSingleInput!
  )
  //デフォルトの工場（単体）
  const [defaultFactoryNo, setDefaultFactoryNo] = useState<number>(
    user.initialParameters.factoryNoForSingleInput!
  )
  //デフォルトの工事区分（単体）
  const [defaultConstruction, setDefaultCondruction] = useState<number>(
    user.initialParameters.constructionForSingleInput!
  )
  const [defaultProductBno, setDefaultProductBno] = useState<string>(
    user.initialParameters.productBnoForSingleInput!
  )
  //デフォルトの伝票番号（単体）
  const [defaultSlipNumber, setDefaultSlipNumber] = useState<string>(
    user.initialParameters.slipNumberForSingleInput!
  )

  //作業開始日
  const [workingDate, setWorkingDate] = useState({
    obj:
      dateStringFromOtherPage !== ''
        ? new Date(dateStringFromOtherPage)
        : new Date(),
    text: formatDate(
      dateStringFromOtherPage !== ''
        ? new Date(dateStringFromOtherPage)
        : new Date()
    ),
  })
  //社員情報
  const [workerInfo, setWorkerInfo] = useState<workerInfoType>({
    workerId:
      workerIdFromOtherPage !== ''
        ? formatWorkerId(workerIdFromOtherPage)
        : user.initialParameters.workerSingleForInput?.workerId
        ? formatWorkerId(user.initialParameters.workerSingleForInput?.workerId)
        : '',
    workerName: user.initialParameters.workerSingleForInput?.workerName ?? '',
    departmentId: null,
    jobId: null,
    departmentName: null,
    place: null,
  })
  console.log('workerInfo', workerInfo.workerId)
  //作業開始・終了時刻
  const [fromTime, setFromTime] = useState('08:00')
  const [toTime, setToTime] = useState('08:00')
  //休憩有無
  const [hasBreak, setHasBreak] = useState(false)
  //休憩時間
  const [breakTime, setBreakTime] = useState(0)

  //合計時間
  const [totalTime, setTotalTime] = useState({
    hour: 0,
    min: 0,
    text: '00時間00分',
  })
  //送信可否
  const [isSendable, setIsSendable] = useState(false)
  useEffect(() => {
    if (fetchDiaryList.length > 0) {
      //取得した日報リストをセット
      // console.log("default fetch");
      setDiaryList(fetchDiaryList)
      setFromTime(fetchDiaryList[0].startTime)
      setHasBreak(fetchDiaryList[0].isBreak)
      setBreakTime(fetchDiaryList[0].breakTime ?? 0)
    } else {
      setDiaryList([])
      setFromTime('08:00')
      setHasBreak(false)
      setBreakTime(0)
    }
  }, [fetchDiaryList, workerInfo.workerName, workingDate.text])
  useEffect(() => {
    //デフォルトをセット
    setDefaultDiary(
      createDefaultDiary(
        workerInfo,
        workingDate.text,
        fromTime,
        toTime,
        totalTime,
        hasBreak,
        breakTime,
        callFrom === 'listByNew' || callFrom === 'list' || callFrom === 'matrix'
          ? initialProductNo
          : defaultProductNo,
        callFrom === 'listByNew' || callFrom === 'list' || callFrom === 'matrix'
          ? initialProductBno
          : defaultProductBno,
        defaultFactoryNo,
        defaultConstruction,
        callFrom === 'listByNew' || callFrom === 'list' || callFrom === 'matrix'
          ? '0000000'
          : defaultSlipNumber
      )
    )
  }, [
    workerInfo,
    fromTime,
    toTime,
    totalTime,
    // hasBreak,
    breakTime,
    workingDate,
    defaultProductNo,
    defaultProductBno,
    defaultFactoryNo,
    defaultConstruction,
    defaultSlipNumber,
  ])
  useEffect(() => {
    setDefaultProductNo(user.initialParameters.productNoForSingleInput!)
    setDefaultProductBno(user.initialParameters.productBnoForSingleInput!)
  }, [
    user.initialParameters.productBnoForSingleInput,
    user.initialParameters.productNoForSingleInput,
  ])
  useEffect(() => {
    setDefaultFactoryNo(user.initialParameters.factoryNoForSingleInput!)
    setDefaultCondruction(user.initialParameters.constructionForSingleInput!)
  }, [
    user.initialParameters.factoryNoForSingleInput,
    user.initialParameters.constructionForSingleInput,
  ])
  useEffect(() => {
    setDefaultSlipNumber(user.initialParameters.slipNumberForSingleInput!)
  }, [user.initialParameters.slipNumberForSingleInput])
  useEffect(() => {
    const res = checkDiaryListSendable(totalTime, diaryList, deleteDiaryList)
    if (res === 0) {
      setIsSendable(true)
    } else {
      setIsSendable(false)
    }
    if (diaryList.length === 0) {
      setTotalTime({
        hour: 0,
        min: 0,
        text: '00時間00分',
      })

      // setFromTime("08:00");
      setToTime(fromTime)
    } else {
      const { hour, min, text, endTime } = calcTotalTimeByDiary(
        fromTime,
        diaryList,
        hasBreak,
        breakTime
      )
      setTotalTime({ hour, min, text })
      setToTime(endTime)
    }
  }, [diaryList])
  // useEffect(() => {
  //   console.log('fetchDiaryList', fetchDiaryList)
  // }, [fetchDiaryList])
  return (
    <div className={classes.rootContainer}>
      <SingleInputHeader
        setTotalTime={setTotalTime}
        totalTime={totalTime}
        setWorkerInfo={setWorkerInfo}
        workerInfo={workerInfo}
        workingDate={workingDate}
        setDefaultFactoryNo={setDefaultFactoryNo}
        setWorkingDate={setWorkingDate}
        hasBreak={hasBreak}
        setHasBreak={setHasBreak}
        breakTime={breakTime}
        setBreakTime={setBreakTime}
        fromTime={fromTime}
        toTime={toTime}
        setFromTime={setFromTime}
        setToTime={setToTime}
        setFetchDiaryList={setFetchDiaryList}
        diaryList={diaryList}
        setDiaryList={setDiaryList}
        setIsShow={setIsShow}
        fromOtherPage={fromOtherPage}
      />
      <SingleInputDetail
        defaultDiary={defaultDiary}
        diaryList={diaryList}
        deleteDiaryList={deleteDiaryList}
        addDiaryList={addDiaryList}
        updateDiaryList={updateDiaryList}
        setDiaryList={setDiaryList}
        totalTime={totalTime}
        setTotalTime={setTotalTime}
        isSendable={isSendable}
        setIsShow={setIsShow}
        fromOtherPage={fromOtherPage}
        callFrom={callFrom}
      />
    </div>
  )
})

export default SingleInputMain
